import apiService from '../infrastructure/api.service.js';
import authStorageService from "./auth-storage.service.js";
import { getAuthEndpoint } from '../infrastructure/endpoint.js';

export const authService = {
    login,
    logout,
    activateCustomerAccount,
    activateAgentAccount,
    passwordReset,
    forgotPassword
};

const ackremittancesVerificationEndpoint = getAuthEndpoint();

async function login(username, password, organizationName) {
    const loginData = {
        "operation": "login",
        "accessToken": "",
        "requestBody": {
            "username": username,
            "password": password,
            "organizationName": organizationName
        }
    };

    try {
        // Use custom request for auth endpoint
        const response = await apiService.customRequest('/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(loginData)
        });
        
        return response;
    } catch (error) {
        // Re-throw the error to maintain the error chain
        throw error;
    }
}

async function activateAgentAccount(token, password) {
    const activationData = {
        "operation": "activate agent",
        "accessToken": "",
        "requestBody": {
            "token": token,
            "password": password
        }
    };

    return apiService.post('/registration/activate/agent', activationData);
}

async function activateCustomerAccount(token) {
    return apiService.get(`/registration/confirm?token=${token}`);
}

async function forgotPassword(email) {
    const resetData = {
        "operation": "ResetPasswordRequest",
        "requestBody": {
            "userName": email
        }
    };

    return apiService.post('/user/resetUserPassword', resetData);
}

async function passwordReset(userName, otp, newPassword) {
    const resetData = {
        "operation": "resetPasswordInitiate",
        "requestBody": {
            "userName": userName,
            "otp": otp,
            "password": newPassword
        }
    };

    return apiService.post('/user/setNewUserPassword', resetData);
}

function logout() { 
    // Clear all authentication data using the storage service
    authStorageService.clearAuthData();
}